export const USER_LOGOUT = "USER_LOGOUT";